import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes$1 from 'prop-types';
import React from 'react';
import { PropTypes } from '@micromag/core';

var styles = {"container":"micromag-element-checkbox-container","label":"micromag-element-checkbox-label","input":"micromag-element-checkbox-input"};

var propTypes = {
  option: PropTypes.textElement,
  value: PropTypes$1.bool,
  onChange: PropTypes$1.func,
  focusable: PropTypes$1.bool,
  checkboxStyle: PropTypes$1.object,
  // eslint-disable-line
  className: PropTypes$1.string
};
var defaultProps = {
  option: null,
  value: null,
  onChange: null,
  focusable: true,
  checkboxStyle: null,
  className: null
};
var Checkbox = function Checkbox(_ref) {
  var option = _ref.option,
    value = _ref.value,
    _onChange = _ref.onChange,
    focusable = _ref.focusable,
    checkboxStyle = _ref.checkboxStyle,
    className = _ref.className;
  var _ref2 = option || {},
    _ref2$body = _ref2.body,
    body = _ref2$body === void 0 ? null : _ref2$body;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    style: _objectSpread({}, checkboxStyle)
  }, /*#__PURE__*/React.createElement("label", {
    className: classNames([styles.label, {
      active: body === value
    }])
  }, /*#__PURE__*/React.createElement("input", {
    className: styles.input,
    type: "checkbox",
    autoComplete: "off",
    value: value === true,
    checked: value === true,
    tabIndex: focusable ? '0' : '-1',
    onChange: function onChange() {
      if (_onChange !== null) {
        _onChange(!value);
      }
    }
  }), body));
};
Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export { Checkbox as default };
